import React from 'react';
import Slider from 'react-slick';


const ProductSlider = () => {
    // Product Slick
    const settings = {
        infinite: false,
        autoplay: false,
        speed: 600,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: true
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: true
                }
            }
        ]
    };
    return (
        <div className="product_view_grid four_col product_slick">
            <Slider {...settings}>
                <div className="item">
                    <div className="product_item">
                        <div className="product_imagebox">
                            <img className="primary_img" src="images/products/10.jpg" alt="img" />
                            <div className="product_item_inner">
                                <div className="button_group">
                                    <a className="button">Add to Cart</a>
                                </div>
                            </div>
                        </div>
                        <div className="label_text">
                            <h5 className="product_item_name"><a href="single-product.html">Cocoa Brownies</a></h5>
                            <div className="rating">
                                <ul>
                                    <li><i className="ion-ios-star"></i></li>
                                    <li><i className="ion-ios-star"></i></li>
                                    <li><i className="ion-ios-star"></i></li>
                                    <li><i className="ion-ios-star-half"></i></li>
                                    <li><i className="ion-ios-star-outline"></i></li>
                                </ul>
                            </div>
                            <h6 className="product_item_price">$65.00</h6>
                        </div>
                    </div>
                </div>

                <div className="item">
                    <div className="product_item">
                        <div className="product_imagebox">
                            <img className="primary_img" src="images/products/11.jpg" alt="img" />
                            <div className="product_item_inner">
                                <div className="button_group">
                                    <a className="button">Add to Cart</a>
                                </div>
                            </div>
                        </div>
                        <div className="label_text">
                            <h5 className="product_item_name"><a href="single-product.html">Choco Marshmallow</a></h5>
                            <div className="rating">
                                <ul>
                                    <li><i className="ion-ios-star"></i></li>
                                    <li><i className="ion-ios-star"></i></li>
                                    <li><i className="ion-ios-star"></i></li>
                                    <li><i className="ion-ios-star-half"></i></li>
                                    <li><i className="ion-ios-star-outline"></i></li>
                                </ul>
                            </div>
                            <h6 className="product_item_price">$25.00</h6>
                        </div>
                    </div>
                </div>

                <div className="item">
                    <div className="product_item">
                        <div className="product_imagebox">
                            <img className="primary_img" src="images/products/12.jpg" alt="img" />
                            <div className="product_item_inner">
                                <div className="button_group">
                                    <a className="button">Add to Cart</a>
                                </div>
                            </div>
                        </div>
                        <div className="label_text">
                            <h5 className="product_item_name"><a href="single-product.html">Cream Cookie</a></h5>
                            <div className="rating">
                                <ul>
                                    <li><i className="ion-ios-star"></i></li>
                                    <li><i className="ion-ios-star"></i></li>
                                    <li><i className="ion-ios-star"></i></li>
                                    <li><i className="ion-ios-star-half"></i></li>
                                    <li><i className="ion-ios-star-outline"></i></li>
                                </ul>
                            </div>
                            <h6 className="product_item_price">$15.00</h6>
                        </div>
                    </div>
                </div>

                <div className="item">
                    <div className="product_item">
                        <div className="product_imagebox">
                            <img className="primary_img" src="images/products/13.jpg" alt="img" />
                            <div className="product_item_inner">
                                <div className="button_group">
                                    <a className="button">Add to Cart</a>
                                </div>
                            </div>
                        </div>
                        <div className="label_text">
                            <h5 className="product_item_name"><a href="single-product.html">Choco Brownies</a></h5>
                            <div className="rating">
                                <ul>
                                    <li><i className="ion-ios-star"></i></li>
                                    <li><i className="ion-ios-star"></i></li>
                                    <li><i className="ion-ios-star"></i></li>
                                    <li><i className="ion-ios-star-half"></i></li>
                                    <li><i className="ion-ios-star-outline"></i></li>
                                </ul>
                            </div>
                            <h6 className="product_item_price">$125.00</h6>
                        </div>
                    </div>
                </div>

                <div className="item">
                    <div className="product_item">
                        <div className="product_imagebox">
                            <img className="primary_img" src="images/products/14.jpg" alt="img" />
                            <div className="product_item_inner">
                                <div className="button_group">
                                    <a className="button">Add to Cart</a>
                                </div>
                            </div>
                        </div>
                        <div className="label_text">
                            <h5 className="product_item_name"><a href="single-product.html">Black Forest Cake</a></h5>
                            <div className="rating">
                                <ul>
                                    <li><i className="ion-ios-star"></i></li>
                                    <li><i className="ion-ios-star"></i></li>
                                    <li><i className="ion-ios-star"></i></li>
                                    <li><i className="ion-ios-star-half"></i></li>
                                    <li><i className="ion-ios-star-outline"></i></li>
                                </ul>
                            </div>
                            <h6 className="product_item_price">$45.00</h6>
                        </div>
                    </div>
                </div>
            </Slider>
        </div>
    );
};

export default ProductSlider;